<template>
  <div class="setting-convert">
    <SettingCard
      class="setting-convert"
      :is-open="isOpened"
      :is-password="true"
      @accordion="accordionToggle"
      @save="onClickSave"
    >
      <template v-slot:title>
        物件名公開設定
      </template>
      <template v-slot:notice>
        各ポータルサイト毎の物件名公開ルールについて設定ができます。設定の変更には管理者パスワードが必要です。
      </template>

      <template v-slot:contents>
        <div>
          <p>各ポータルサイト毎の物件名公開ルールについて設定ができます。</p>
          <ul class="list">
            <li>・ここで設定された物件名公開ルールに基づき各サイトへコンバート出稿されます。</li>
            <li>
              ・各物件の物件名公開可否の状態よりも優先されるルールとなりますので、ご注意ください。
            </li>
            <li class="list__notice">・他店舗の物件名表示切替を設定する際は他店舗との情報共有をお願いいたします。</li>
          </ul>

          <table class="table-status">
            <tr>
              <th class="table-status__header">物件情報に従う</th>
              <td class="table-status__data">
                物件毎に保存された「物件名表示可サイト」の状況のまま送信されます。
              </td>
            </tr>
            <tr>
              <th class="table-status__header">物件名公開</th>
              <td class="table-status__data">
                全ての物件は物件名を強制的に【表示】にして送信します。
              </td>
            </tr>
            <tr>
              <th class="table-status__header">物件名非公開</th>
              <td class="table-status__data">
                全ての物件は物件名を強制的に【非表示】にして送信します。
              </td>
            </tr>
          </table>

          <div>
            <template v-if="convertSettings && convertSettings.length > 0">
              <div v-for="(item, itemIdx) in convertSettings" :key="itemIdx" class="site-list">
                <div class="site-title">
                  <div class="shop_name">{{ item.shop_name }}</div>
                </div>

                <template v-for="(site, siteIdx) in item.portalsites">
                  <table class="table" :key="siteIdx">
                    <tr>
                      <th class="table__header">{{ site.label }}</th>
                      <td>
                        <i-radio-group v-model="site.status" type="button" size="small">
                          <i-radio label="I">物件情報に従う</i-radio>
                          <i-radio label="D">物件名公開</i-radio>
                          <i-radio label="N">物件名非公開</i-radio>
                        </i-radio-group>
                      </td>
                    </tr>
                  </table>
                </template>
              </div>
            </template>
          </div>
        </div>
      </template>
    </SettingCard>
    <ModalPassword :modal.sync="modalPassword" @authentication="afterAuth" />
  </div>
</template>

<script>
import { RadioGroup, Radio } from 'view-design'
import SettingCard from '@/components/parts/SettingCard'
import ModalPassword from '@/components/templates/modal/Password'
import SettingRepository from '@/repositories/settingRepository'
export default {
  components: {
    'i-radio-group': RadioGroup,
    'i-radio': Radio,
    SettingCard,
    ModalPassword,
  },
  props: {
    type: {
      type: String,
      default: '',
      required: true,
      validator: function(value) {
        return ['investment', 'residence'].indexOf(value) !== -1
      },
    },
  },
  data() {
    return {
      isOpened: false,
      modalPassword: false,
      convertSettings: [],
    }
  },
  computed: {},
  methods: {
    // アコーディオン 開閉処理
    accordionToggle: function() {
      if (!this.isOpened) {
        this.modalPassword = true
      } else {
        this.isOpened = false
        this.resetParams()
      }
    },
    // 認証後の処理
    afterAuth() {
      this.getConvertDisplays()
    },
    async getConvertDisplays() {
      this.$store.dispatch('Loading/setLoading', true)
      await SettingRepository.getConvertDisplays(this.type)
        .then(data => {
          if (data.result) {
            this.convertSettings = data.data
            this.isOpened = true
          } else {
            alert('物件名公開設定の取得に失敗しました。')
          }
        })
        .catch(e => {
          console.log(e)
          alert('物件名公開設定の取得に失敗しました。')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // サイト設定登録処理
    async onClickSave() {
      this.$store.dispatch('Loading/setLoading', true)
      await SettingRepository.putConvertDisplays(this.convertSettings, this.type)
        .then(data => {
          if (data.result) {
            alert('物件名公開設定を更新しました。')
          } else {
            alert('物件名公開設定の更新に失敗しました。')
          }
        })
        .catch(e => {
          console.log(e)
          alert('物件名公開設定の更新に失敗しました。')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // パラメーターリセット
    resetParams() {
      this.convertSettings = []
    },
  },
}
</script>

<style lang="scss" scoped>
.setting-convert {
  .list {
    list-style: none;
    margin-bottom: 16px;
    &__notice {
      color: #f00;
    }
  }
  .table-status {
    border-collapse: collapse;
    width: 100%;
    margin: 12px 0 18px;
    font-size: 12px;
    &__header {
      border: 1px solid #ddd;
      padding: 4px 8px;
      text-align: left;
    }
    &__data {
      border: 1px solid #ddd;
      padding: 4px 8px;
    }
  }
  .site-list {
    margin-bottom: 24px;
    .container {
      position: relative;
      min-height: 200px;
    }
    .site-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 2px;
      margin-bottom: 8px;
      border-bottom: 1px solid #cfcfcf;
    }
    .shop_name {
      font-weight: bold;
    }
    .table {
      width: 100%;
      &__header {
        width: 120px;
      }
    }
  }
}
</style>
